import request from "../index";

// 获取解决方案分类
export function solutionType(postdata){
  return request({
      method:"get",
      url:"/solutionType/web/tree/",
      data:postdata,
      isparams:true
  })
}

// 根据分类Id获取官网分页列表
export function solutiondetail(postdata){
  return request({
      method:"post",
      url:"/solution/web/page",
      data:postdata
  })
}

// 官网解决方案详情
export function solutionInfo(postdata){
  return request({
      method:"get",
      url:"/solution/web/info/",
      data:postdata,
      isparams:true
  })
}




// WEBPACK FOOTER //
// ./src/api/modules/solution.js